import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent, Fragment } from "react";
import { commonInputStyles } from "../common-inputs.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
class TextInput extends PureComponent {
    render() {
        const { inputData, errorState, onInputChange, onInputBlur, invalid, errorLabelId, id, defaultValue, translate } = this.props;
        const { inputName, type, isRequired, placeholder } = inputData;
        const { isValid } = errorState;
        const showRequiredError = !isValid && isRequired;
        const requiredClass = {
            "input-required": showRequiredError
        };
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx("input", {
                    id: id,
                    onChange: onInputChange,
                    onBlur: onInputBlur,
                    name: inputName,
                    type: type,
                    placeholder: translate(placeholder),
                    "aria-required": isRequired,
                    "aria-invalid": invalid,
                    "aria-describedby": errorLabelId,
                    defaultValue: defaultValue,
                    className: `jsx-${commonInputStyles.__hash}` + " " + (classnames("hp-input hp-text-input", requiredClass) || "")
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: commonInputStyles.__hash,
                    children: commonInputStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
TextInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
export default withGenericConfig(TextInput);
